import React, { useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { faAngleRight, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../services/apiService';
import SettingsTabs from '../../components/common/SettingsTabs';
import JoditEditor from 'jodit-react';
import debounce from 'lodash.debounce';
import { toast } from 'react-toastify';
function SettingsTerms() {
    const navigate = useNavigate();
    const contentRef = useRef("");
    const [errorMessage, setErrorMessage] = useState('');
    const [cancel, setCancels] = useState(false);
    const [loading, setLoading] = useState(true);
    const [submitloader, setSubmitloader] = useState("");
    // const [value, setValue] = useState(dayjs(null));
    const [errors, setErrors] = useState({});
    
    const debouncedOnChange = debounce((value) => {
        const cleanValue = value === "<p><br></p>" ? "" : value;
        contentRef.current = cleanValue;
    }, 500);
    
    
    const [formData, setFormData] = useState({
        terms: '',
        id: '',
    });

    useEffect(() => {
        const fetchPreviewData = async () => {
            try {
                const response = await apiService.postRequest(`latest/terms`);
                if (response && response.success) {
                    contentRef.current = response.data.content;
                    setFormData({
                        terms: response.data.content,
                        id: response.data.id,
                    });
                }else{
                    toast.error(response.message || "Something went wrong!");
                    if(response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            } catch (err) {
                console.error(err);
            }finally{
                setLoading(false);
                setCancels(false);
                setErrorMessage("");
                setErrors({});
            }
        };

        fetchPreviewData();
    }, [cancel]);


    const validateForm = (data) => {
        let valid = true;
        const errors = {};
        if (!data.terms || data.terms.trim() === '') {
            errors.terms = 'Terms and Conditions is required.';
            valid = false;
        }
        setErrors(errors);
        return valid;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        const contentValue = contentRef.current;
        
        const updatedFormData = {
            ...formData,
            terms: contentValue,
        };
        if (!validateForm(updatedFormData)) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }
        setFormData(updatedFormData);
        setSubmitloader(true);
        setErrorMessage("");
        setErrors({});
        try {
            const jsonParams = {
                ...updatedFormData
            };
            const response = await apiService.postRequest(`admin/terms/save`, jsonParams);
            if (response && response.success) {
                toast(response.message || 'An error occurred during submission.');
            } else {
                setErrorMessage(response.message || 'An error occurred during submission.');
                toast.error(response.message || 'An error occurred during submission.');
                if(response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        } finally {
            setSubmitloader(false);
        }
    };
    const handleNewContent = () => {
        setFormData({
            terms: '',
            id: '',
        });
        contentRef.current = "";
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Company Settings</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Company Settings <FontAwesomeIcon className='angleright' icon={faAngleRight} /> General</span>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="flex-start" className="statusselectbtn my-5">
                        <SettingsTabs/>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="center">
                    {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                        <form className='w-100' 
                        onSubmit={handleSubmit}
                        >
                        <Grid size={{lg:12,xs:12}} container justifyContent="space-between">
                            <Grid size={{xs:12}} container justifyContent="flex-end">
                                <button type='button' style={{width:"max-content"}} onClick={handleNewContent} className='registersendbtn2 my-0 px-4'><FontAwesomeIcon icon={faPlus} /> New Version</button>
                            </Grid>
                            <Grid size={{xs:12}} container className="mt-5 editor_sunsinput">
                            <span className='fw-semibold mb-2'>Terms and Conditions</span>
                            <JoditEditor
                                value={formData.terms}
                                config={{
                                    pasteHTML: '', // default paste content
                                    cleanHTML: false,
                                    askBeforePasteHTML: false,
                                    askBeforePasteFromWord: false,
                                    disablePlugins: ['pasteStorage'], // optionally disable paste-related cleanup plugins
                                    iframe: false, // make sure iframe is off
                                    editHTMLDocumentMode: false,
                                    enableDragAndDropFileToEditor: false,
                                    processPasteHTML: html => {
                                    return html.replace(/</g, '&lt;').replace(/>/g, '&gt;');
                                    },
                                    enter: 'BR',
                                    beautifyHTML: false,
                                    events: {
                                        onPaste: (event) => {
                                            console.log("Pasted!", event);
                                        },
                                    },
                                    paste: {
                                    cleanOnPaste: false,
                                    replaceNewlines: false
                                    },
                                    controls: {
                                        font: {
                                            list: {
                                                'calibri': 'Calibri'
                                            }
                                        },
                                        removeFormat: {
                                            name: 'removeFormat',
                                            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M178.5 416l123 0 65.3-65.3-173.5-173.5-126.7 126.7 112 112zM224 480l-45.5 0c-17 0-33.3-6.7-45.3-18.7L17 345C6.1 334.1 0 319.4 0 304s6.1-30.1 17-41L263 17C273.9 6.1 288.6 0 304 0s30.1 6.1 41 17L527 199c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41l-135 135 120 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0z"/></svg>',
                                            tooltip: 'Remove Format',
                                        },
                                        removeBg: {
                                            name: "removeBg",
                                            tooltip: "Remove Background Color",
                                            icon: "eraser",
                                            exec: (editor) => {
                                            editor.s.focus();
                                        
                                            const sel = editor.s.sel;
                                            if (sel && sel.rangeCount > 0) {
                                                const range = sel.getRangeAt(0);
                                                const contents = range.cloneContents();
                                                const div = editor.ownerDocument.createElement("div");
                                                div.appendChild(contents);
                                        
                                                // Remove background-color from all styles in selection
                                                const elements = div.querySelectorAll("*");
                                                elements.forEach(el => {
                                                if (el.style && el.style.backgroundColor) {
                                                    el.style.backgroundColor = "";
                                                }
                                                });
                                        
                                                // Replace selected HTML with cleaned version
                                                editor.selection.remove();
                                                editor.selection.insertHTML(div.innerHTML);
                                            }
                                            }
                                        },
                                        fontsize: {
                                            list: {
                                            "12px": "Paragraph - 12",
                                            "14px": "Small - 14",
                                            "16px": "Default - 16",
                                            "18px": "Medium - 18",
                                            "24px": "Large - 24"
                                            }
                                        },                                              
                                    },
                                    width: "100%",
                                    minWidth: "500px",
                                    toolbarAdaptive: false,
                                    toolbarSticky: false,
                                    buttons: [
                                        "source", "|",
                                        "bold", "italic", "underline", "strikethrough","spellcheck", "|",
                                        "fontsize", "brush","removeBg", "|", // Font size, font style, text color // "font",
                                        "ul", "ol", "|",
                                        "align", "|",
                                        "image", "table", "link", "|",
                                        "undo", "redo", "removeFormat", "|",
                                        "hr", "fullsize"
                                    ],
                                    useIframe: false,
                                    showCharsCounter: false, // Hides character counter
                                    showWordsCounter: false, // Hides word counter
                                }}
                                onChange={debouncedOnChange}
                            />
                                {errors.terms && <p style={{color:"Red"}}>{errors.terms}</p>}
                            </Grid> 
                            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                            <Grid size={{sm:12,xs:12}} container className="gap-3 my-3">
                                <button type='button' className='registersendbtn1' onClick={()=>setCancels(true)}>Cancel</button>
                                <button type="submit" className='registersendbtn2'>{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                            </Grid>
                        </Grid>
                    </form>
                    </>}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default SettingsTerms
